import {Toast} from 'antd-mobile/es'

import projectConfig from '../../config'
import axios from './axios'
import {generateSecureNonce, getBrowserFingerprint, isBrowser} from './helper'

interface ReqParams {
  url: string
  params: any
  method?: 'get' | 'post'
  needToken?: boolean // 是否需要token
  useOrigin?: boolean // 是否使用原始域名
  returnAll?: boolean
}

function fullURL(url: string) {
  const {proxies = []} = projectConfig[ENV]
  for (let i = 0; i < proxies.length; i += 1) {
    const {match, map, host} = proxies[i]
    if (match.test(url)) {
      const realURL = host + map(url)
      return isBrowser() ? url : realURL
    }
  }
  return url
}

/**
 * 按键名字典序排序对象
 * @param obj 要排序的对象
 * @returns 排序后的新对象
 */
const sortObjectByKeys = (obj: Record<string, any>): Record<string, any> => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  const sortedObj: Record<string, any> = {}
  Object.keys(obj)
    .sort() // 按键名字典序排序
    .forEach((key) => {
      sortedObj[key] = obj[key]
    })
  return sortedObj
}

// 从 Redux store 获取用户信息
const getUserFromStore = () => {
  // 浏览器端：从 window.store 获取
  if (isBrowser() && typeof window !== 'undefined' && window.store) {
    const {store} = window
    return store.getState()?.account?.user || null
  }
  // 服务端或 fallback：从 localStorage 获取
  try {
    const savedUser = localStorage.getItem('user')
    if (savedUser) {
      return JSON.parse(savedUser)
    }
  } catch (e) {
    // 忽略解析错误
  }
  return null
}

const getCommonData = async () => {
  const user = getUserFromStore()
  return {
    nonce: await generateSecureNonce(),
    deviceId: await getBrowserFingerprint(),
    h_m: user?.member_info?.id || 0,
    h_did: 'test_device_id',
    h_av: '1.0.0',
    h_dt: 1,
    h_ch: 'google',
    h_model: 'web',
    h_nt: 1,
    h_os: 'web',
    h_app: 'test_app',
    h_ts: 1700000000,
    token: user?.token || 'xxx',
    from: 'web',
    h_loc: {
      lat: 0.0,
      lon: 0.0,
    },
  }
}

const tokenHanlder = () => {
  Toast.clear()
}

export async function req(args: ReqParams): Promise<any> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const {
      url,
      params,
      method = 'post',
      needToken = false,
      useOrigin = false,
      returnAll = false,
    } = args
    const commonData = await getCommonData()
    const currentUrl = useOrigin ? url : fullURL(url)
    const globalParams = {
      ...params,
      ...commonData,
    }
    const currentParams = useOrigin ? params : globalParams

    const requestParams =
      method === 'get'
        ? {params: sortObjectByKeys(currentParams)}
        : {...sortObjectByKeys(currentParams)}
    if (needToken) {
      // 获取token
    }
    // console.log('[request] req ===> ', currentParams)
    try {
      const res: any = await axios[method](currentUrl, requestParams)
      // console.log('[request] res ===> ', res)
      if (returnAll) {
        resolve(res)
        return
      }
      if (+res.code === 0 || +res.ret === 1) {
        resolve(res.data)
        return
      }
      const tokenLoseEffective = res.ret === -1006 || res.ret === -1007
      // token 失效
      if (tokenLoseEffective && isBrowser()) {
        tokenHanlder()
        return
      }
      reject(new Error(res.msg))
    } catch (error) {
      // console.error('[request] error ===> ', error)
      reject(error)
    }
  })
}

export async function reqLog(args: any) {
  const data = await getCommonData()
  const params = {
    ...data,
    list: [args],
    cancelType: 3,
  }
  const url = fullURL('/xs-api/stat/action')
  axios.post(url, {...params})
}
